import { FieldTests } from "restaumatic-client";
import { freeDeliveryWithoutAdressEqualSplit } from "./experiments/FreeDeliveryWithoutAdressEqualSplit";
import { freeDeliveryWithAdressEqualSplit } from "./experiments/FreeDeliveryWithAdressEqualSplit";
import { cartCrossSellingListView } from "./experiments/cartCrossSellingListView";
import { addToCartCrossSellingBottomSheet } from "./experiments/AddToCartCrossSellingBottomSheet";
/**
 * This divides sites into groups that can be used in experiments.
 * Good practices:
 * - assign only one experiment to the group
 * - groups should not overlap
 */
export const siteGroups = {
    even: (siteId) => siteId % 2 === 0,
    odd: (siteId) => siteId % 2 !== 0,
};
/**
 * Global instance for initialising and getting experiments' data.
 */
const fieldTest = new FieldTests();
export default {
    init() {
        fieldTest.applyExperiments([]);
        fieldTest.cleanUpAfterOtherTestsThan([
            freeDeliveryWithoutAdressEqualSplit,
            freeDeliveryWithAdressEqualSplit,
            cartCrossSellingListView,
            addToCartCrossSellingBottomSheet,
        ]);
    },
    getVariant(experiment) {
        return fieldTest.getVariant(experiment);
    },
    apply(experiment) {
        fieldTest.applyExperiments([experiment]);
    },
};
